import { AgResourceLanguage } from '../types';
import { orderDetails as EnUsOrderDetails } from '../en-us/orderDetails';

export const orderDetails: AgResourceLanguage['orderDetails'] = {
  ...EnUsOrderDetails,
  returnBackButton: 'Retour aux commandes',
  upcomingOrderDetails: {
    pageTitle: 'Commande d’abonnement',
    orderDefaultStatus: 'Non payé',
    orderInformation: {
      orderDateLabel: 'Date de commande',
      subscriptionNameLabel: 'Abonnement',
      statusLabel: 'Statut',
      totalLabel: 'Total'
    },
    shipNowButton: 'Expédier maintenant',
    skipShipmentButton: 'Sauter l’expédition',
    changeDateButton: 'Date de commande',
    subscriptionProductsList: 'Produits de l’abonnement :',
    manageSubscriptionButton: 'Gérer l’abonnement',
    emptyOrders: {
      title: 'Ajouts uniques',
      description:
        'Parcourez la gamme complète des produits et accessoires AG1, exclusivement disponibles pour les membres.',
      buttonName: 'Ajouter un produit à la commande'
    },
    oneTimeField: {
      oneTimeProductsList: 'Ajouts uniques',
      addProducrToOrderButton: 'Ajouter un produit à la commande',
      oneTimeSubtottal: 'Sous-total des ajouts uniques'
    }
  },
  pastOrdersDetails: {
    pageTitle: 'Commande',
    freeGiftTitle: 'Partager des packs gratuits',
    orderItems: 'Articles de la commande',
    trackOrderButton: 'Suivre la commande',
    subscriptionNameOTP: 'Achat unique',
    defaultOrderStatus: 'Non disponible',
    orderInformation: {
      orderDateLabel: 'Date de commande',
      subscriptionNameLabel: 'Abonnement',
      statusLabel: 'Statut',
      totalLabel: 'Total'
    }
  },
  missingValue: 'Non disponible'
};
